import { useEffect, useState } from "react";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import {  validateTaxInfoForm } from "../../utility/validationRules";
import { FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Col, Modal, Row } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import { InfoText, PaymentGatewayContainer } from "../machineInstalRequest/styles";
import { billSingularPay, machineInstallManualPay, updateTaxInfo } from "../../api/api";
import CustomSelect from "../../components/_common/CustomSelect";
import { payTypes } from "../../constants";
import CustomTextArea from "../../components/_common/CustomTextArea";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { loginAfterEnterTaxInfo, logout } from "../../redux/reducers/authSlice";

export const TaxInfoDialog: React.FC<FormProps> = ({visible,onSubmit,onCancel,payLoad,setShowDialog}) => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(validateTaxInfoForm) as any
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const [isLoading,setIsLoading] = useState(false);
    const [isSubmiting,setIsSubmiting] = useState(false);

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect( ()=>{

        setValues({...values,
            str_TaxnationalCode:payLoad.str_TaxnationalCode,
            str_Economicode:payLoad.str_Economicode,
            str_TaxFullNameOwnernationalCode:payLoad.str_TaxFullNameOwnernationalCode,
            str_PostalCode:payLoad.str_PostalCode,
            Str_Address:payLoad.Str_Address,
            Str_DirectTel:payLoad.Str_DirectTel,
        })

    },[payLoad])

    const onSubmitForm = (e:any) => {
        e.preventDefault();
        
        let error= validateTaxInfoForm(values);
        if (Object.keys(error).length == 0)
        {
            setIsSubmiting(true)

            updateTaxInfo(
                myStore.auth.userId,
                values.str_Economicode,
                values.str_TaxnationalCode,
                values.str_PostalCode,
                values.str_TaxFullNameOwnernationalCode,
                values.Str_Address,
                values.Str_DirectTel,
            ).then((result: any) => {
                    sucessNotify("اطلاعات با موفقیت ثبت شد", undefined, 5000)
                    setIsSubmiting(false)
                    dispatch(loginAfterEnterTaxInfo({}))
                    onCancel();
            }).catch((error) => {
                    console.log(error);
                    setIsSubmiting(false)
                    dispatch(logout())
                    errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
        }
        else
        {
            setErrors(error);
        }
 
    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                {isLoading === true && (
                            <Spinner/>
                )}

                {isLoading === false && (

                    <FormContainer title="ثبت اطلاعات مالیاتی" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >
                
                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="str_TaxnationalCode"
                                    placeholder="کد ملی آزمایشگاه/صاحب مرکز"
                                    value={values.str_TaxnationalCode || ""}
                                    onChange={handleChange}
                                />
                                <ValidationType type="str_TaxnationalCode" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="str_Economicode"
                                    placeholder="کد اقتصادی"
                                    value={values.str_Economicode || ""}
                                    onChange={handleChange}
                                />
                                <ValidationType type="str_Economicode" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="str_TaxFullNameOwnernationalCode"
                                    placeholder="اسم کامل/ثبت شده آزمایشگاه"
                                    value={values.str_TaxFullNameOwnernationalCode || ""}
                                    onChange={handleChange}
                                />
                                <ValidationType type="str_TaxFullNameOwnernationalCode" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="str_PostalCode"
                                    placeholder="کد پستی"
                                    value={values.str_PostalCode || ""}
                                    onChange={handleChange}
                                />
                                <ValidationType type="str_PostalCode" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="Str_DirectTel"
                                    placeholder="شماره تلفن"
                                    value={values.Str_DirectTel || ""}
                                    onChange={handleChange}
                                />
                                <ValidationType type="Str_DirectTel" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="Str_Address"
                                    placeholder="آدرس پستی"
                                    value={values.Str_Address || ""}
                                    onChange={handleChange}
                                />
                                <ValidationType type="Str_Address" />
                            </Col>
                        </Row>


                    </FormContainer>

                )}
            </>
            
        </Modal>
    )
}